import React from 'react'
import PropTypes from 'prop-types'
import ImagePlaceholder from 'Components/ImagePlaceholder'
import { useConfiguration } from 'Root/ConfigurationProvider'


import {
  _AgentPreview,
  _Name,
  _Content,
  _BoxLink,
  _PreviewContainer,
  _InfoContainer,
  _Position,
  _AgentBrokerageName,
} from './styles'

export const getComingSoonImageUrl = (THEME_NAME) => `/static/images/${THEME_NAME}-agent-photos-coming-soon.webp`

const AgentPreview = ({
  image, fullname, jobtitle, brokerageName,
  url, id, agent = null, setTargetComponent,
}) => {
  const { THEME_NAME } = useConfiguration()
  const comingSoonImg = getComingSoonImageUrl(THEME_NAME)
  return (
    <_AgentPreview xs={6} sm={4} md={3} >
      <_Content>
        <_BoxLink
          data-test-id="agentPreviewLink"
          componentData={{ component: 'Agent', id, pageData: agent }}
          setTargetComponent={setTargetComponent}
          to={`/${url}`}
          alt={fullname}
          title={fullname}
        >
          <_PreviewContainer>
            <ImagePlaceholder src={image} defaultSrc={comingSoonImg} alt={fullname} width={348} height={348} />
          </_PreviewContainer>
          <_InfoContainer>
            <_Name>{fullname}</_Name>
            <_Position>{jobtitle}</_Position>
            {
              brokerageName && brokerageName.includes('Property') ?
                <_AgentBrokerageName>
                  {brokerageName}
                </_AgentBrokerageName>
                : ''
            }
          </_InfoContainer>

        </_BoxLink>
      </_Content>
    </_AgentPreview>
  )
}

AgentPreview.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  image: PropTypes.string.isRequired,
  fullname: PropTypes.string.isRequired,
  jobtitle: PropTypes.string.isRequired,
  brokerageName: PropTypes.string,
  url: PropTypes.string.isRequired,
  agent: PropTypes.shape({}),
  setTargetComponent: PropTypes.func,
}

export default AgentPreview
